import { render, staticRenderFns } from "./SelectedStep.vue?vue&type=template&id=3f54cb12&scoped=true&lang=pug"
import script from "./SelectedStep.vue?vue&type=script&lang=ts"
export * from "./SelectedStep.vue?vue&type=script&lang=ts"
import style0 from "./SelectedStep.vue?vue&type=style&index=0&id=3f54cb12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54cb12",
  null
  
)

export default component.exports